<template>
  <div id="__nuxt" style="">
    <div class="pc video-name-id-episode___en" data-v-79cdd511="" style="height: 100vh">
      <HeadTop></HeadTop>
      <div class="n-config-provider">
        <div class="page-a">
          <div class="play pc_container" data-v-83ae33d0="">
            <!-- 面包屑 -->
            <div class="video_breadcrumb" style="display: flex">
              <router-link to="/" class="home_link" data-v-87454007="">Home</router-link>
              <span class="split" data-v-87454007="">/</span>
              <h2 class="title_dir" data-v-87454007="">
                <router-link :to="{ name: 'video', query: { code: video.code } }" data-v-87454007="">{{ video.title }}</router-link>
              </h2>
              <span class="split" data-v-87454007="">/</span>
              <h2 class="title_dir" data-v-87454007="">{{ current.title }}</h2>
            </div>

            <!-- 视频播放器 -->
            <div class="video_wrap" data-v-83ae33d0="">
              <div class="video_inner" data-v-83ae33d0="">
                <!-- 播放器 + 选集 左右布局 -->
                <div class="player-layout">
                  <!-- 左侧：播放器 - 固定大小 -->
                  <div class="player-container">
                    <div class="player-wrapper">
                      <video ref="video" autoplay controls controlslist="nodownload noplaybackrate" disablePictureInPicture :poster="video.img" :src="current.url" @play="onPlay" @pause="onPause">
                        <source :src="current.url" type="application/x-mpegURL" />
                      </video>
                    </div>

                    <!-- 解锁弹框 - 优化版 -->
                    <div class="tk1box" :class="{ tbup: showUnlock }">
                      <!-- 顶部提示 -->
                      <div class="xkg1t">
                        <div class="lock-icon-wrapper">
                          <LockOutlined />
                        </div>
                        <span class="lock-tip">{{ $t('_sp._xyjscl') }}</span>
                      </div>

                      <!-- 余额信息 -->
                      <div class="tb2bx">
                        <div class="balance-wrap">
                          <img src="@/static/jinb.png" class="coin-icon" />
                          <span class="balance-amount">{{ wallet?.video || 0 }}</span>
                        </div>
                        <router-link :to="{ name: 'transfer' }" class="recharge-link">{{ $t('_sp._cz') }} →</router-link>
                      </div>

                      <!-- 解锁按钮 -->
                      <div class="tb33x">
                        <button class="unlock-btn unlock-all" @click="onUnlockAll">
                          <span class="btn-price">${{ video.total_amount || 0 }}</span>
                          <span class="btn-label">{{ $t('_sp._jsqj') }} ({{ video.video_total - video.u_unlock_num }})</span>
                        </button>
                        <button class="unlock-btn unlock-one" @click="onUnlockOne">
                          <span class="btn-price">${{ video.unit_price || 0 }}</span>
                          <span class="btn-label">{{ $t('_sp._jsbj') }}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- 右侧：剧集列表 -->
                  <div class="episode-sidebar">
                    <div class="episode-header">
                      <span class="episode-title">{{ video.title }}</span>
                      <span class="episode-count">{{ $t('_sp._gdsj', { n: videoList.length }) }}</span>
                    </div>
                    <div class="episode-list">
                      <div v-for="(item, i) in videoList" :key="item.id || i" class="episode-item" :class="{ active: selectIndex == i, locked: item.is_vip == 2 && item.u_vip == 0, watched: item.u_vip == 2 }" @click="setCurrent(i)">
                        <span class="episode-num">{{ item.sort + 1 }}</span>
                        <span class="episode-label">{{ item.title }}</span>
                        <span class="episode-status">
                          <span v-if="item.is_vip == 2 && item.u_vip == 0" class="lock-icon">🔒</span>
                          <span v-else-if="item.u_vip == 2" class="check-icon">✓</span>
                          <span v-else class="play-icon">▶</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 视频信息 -->
            <div class="content-wrapper" data-v-83ae33d0="">
              <div class="content" data-v-83ae33d0="">
                <h2 class="name" data-v-83ae33d0="">{{ video.title }} - {{ current.title }}</h2>
                <div class="desc_wrap showMore" data-v-83ae33d0="">
                  <h3 class="desc" data-v-83ae33d0="">{{ video.content || video.desc }}</h3>
                </div>
                <ul class="tag" data-v-83ae33d0="">
                  <h3 class="link_item" v-for="tag in video.tags" :key="tag.id" data-v-83ae33d0="">
                    <router-link :to="{ name: 'genres', params: { cateId: tag.id } }">{{ tag.name }}</router-link>
                  </h3>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付确认弹窗 -->
    <Toast ref="payToast" :title="toast.title" :desc="toast.desc" :okText="$t('_sp._qrzf')" :cancel-text="$t('_sp._qx')" :ok="onUnlockOk" :cancel="onUnlockCancel"></Toast>
  </div>
</template>

<script>
import { LockOutlined } from '@ant-design/icons-vue'
import HeadTop from '@/components/base/head.vue'
import Toast from '@/components/toast/toast.vue'

export default {
  name: 'VideoVue',
  components: {
    HeadTop,
    LockOutlined,
    Toast
  },
  data() {
    return {
      code: '',
      wallet: {},
      video: {},
      videoList: [],
      current: {},
      selectIndex: 0,
      showUnlock: false,
      toast: {
        type: 0,
        title: '',
        desc: ''
      }
    }
  },
  created() {
    const { code } = this.$route.query
    if (code) {
      this.code = String(code)
      this.initData()
    } else {
      this.$message.warning('缺少视频参数')
      this.$router.push('/')
    }
  },
  methods: {
    initData() {
      this.getUserState()
      this.getVideo()
    },
    onPlay() {
      console.log('播放开始')
    },
    onPause() {
      console.log('暂停播放')
    },
    getUserState() {
      if (!this.$common.isLogin()) return
      this.$api.userWallet.getWallet().then((res) => {
        this.wallet = res.data || {}
      })
    },
    getVideo() {
      this.$api.video
        .getVideo({ code: Number(this.code) })
        .then((res) => {
          this.video = res.data || {}
          this.getVideoItemList()
        })
        .catch(() => {
          this.$message.error('获取视频信息失败')
        })
    },
    getVideoItemList() {
      this.$api.video
        .getVideoItemList({ code: Number(this.code) })
        .then((res) => {
          this.videoList = res.data || []
          if (this.videoList.length > 0) {
            this.setCurrent(0)
          }
        })
        .catch(() => {
          this.$message.error('获取剧集列表失败')
        })
    },
    setCurrent(index) {
      if (index < 0 || index >= this.videoList.length) return

      const item = this.videoList[index]
      this.selectIndex = index
      this.showUnlock = false

      if (item.is_vip === 2 && item.u_vip !== 2) {
        this.current = item
        this.onUnlockToast()
        return
      }

      this.current = item
    },
    onUnlockToast() {
      this.showUnlock = true
    },
    onUnlockAll() {
      if (!this.$common.isLogin()) {
        this.onUnSignin()
        return
      }
      const count = this.video.video_total - this.video.u_unlock_num
      this.toast = {
        type: 1,
        title: this.$t('_sp._jsqj'),
        desc: this.$t('_sp._jsqjjs', { a: this.video.total_amount || 0 }) + `（剩余 ${count} 集）`
      }
      this.$refs.payToast?.open()
    },
    onUnlockOne() {
      if (!this.$common.isLogin()) {
        this.onUnSignin()
        return
      }
      this.toast = {
        type: 2,
        title: this.$t('_sp._jsbj'),
        desc: this.$t('_sp._jsbjjs', { a: this.video.unit_price || 0 })
      }
      this.$refs.payToast?.open()
    },
    onUnlockOk() {
      this.$message.loading({ content: this.$t('_sp._zfz'), key: 'msg' })

      const apiCall = this.toast.type === 1 ? this.$api.userWallet.payUnlockAll({ code: this.video.code }) : this.$api.userWallet.payUnlockOne({ code: this.current.code })

      apiCall
        .then((res) => {
          if (res.code === 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          this.$message.success({ content: res.msg || '解锁成功', key: 'msg' })
          this.getVideo()
          this.getVideoItemList()
          setTimeout(() => this.getUserState(), 1000)
        })
        .catch(() => {
          this.$message.error({ content: '解锁失败，请重试', key: 'msg' })
        })
        .finally(() => {
          this.$refs.payToast?.close()
        })
    },
    onUnlockCancel() {
      this.$refs.payToast?.close()
    },
    onUnSignin() {
      this.$message.warning('请先登录')
      this.$router.push({ name: 'login' })
    },
    addCollect() {
      const id = this.current.id
      const index = this.selectIndex

      this.$api.video.addCollect({ vi_id: id }).then((res) => {
        if (res.code === 1) {
          this.$message.warning({ content: res.msg, key: 'msg' })
          return
        }
        const item = this.videoList[index]
        item.u_collect = res.data.u_collect
        item.collect = parseInt(item.collect) + (res.data.u_collect === 2 ? 1 : -1)
      })
    }
  }
}
</script>

<style scoped>
/* ===== 引入原有样式 ===== */
</style>

<style>
/* ============================================================
   黑色主题 - 视频播放页面
   ============================================================ */

/* ----- 页面背景 ----- */
.pc.video-name-id-episode___en {
  background: #0b0d0f;
}

.page-a {
  background: #131313;
  min-height: calc(100vh - 71px);
}

.pc_container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
}

/* ----- 面包屑 ----- */
.video_breadcrumb {
  padding: 12px 0 20px;
  background: transparent;
}

.video_breadcrumb .home_link,
.video_breadcrumb .title_dir a {
  color: #8a949f;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s;
}

.video_breadcrumb .home_link:hover,
.video_breadcrumb .title_dir a:hover {
  color: #e8edf2;
}

.video_breadcrumb .title_dir {
  color: #e8edf2;
  font-size: 14px;
  font-weight: 500;
}

.video_breadcrumb .split {
  color: #3a4652;
  margin: 0 8px;
}

/* ============================================================
   播放器 + 选集 左右布局
   ============================================================ */
.player-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

/* ============================================================
   播放器 - 固定大小 800x450
   ============================================================ */
.player-container {
  flex: 0 0 1220px;
  position: relative;
  overflow: hidden;
}

.player-wrapper {
  position: relative;
  height: 600px;
  background: #0a0c0e;
  border-radius: 12px;
  overflow: hidden;
}

.player-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #0a0c0e;
}

/* ============================================================
   右侧选集侧边栏
   ============================================================ */
.episode-sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #0f1419;
  border-radius: 16px;
  border: 1px solid #1a1f26;
  overflow: hidden;
  max-height: 600px;
  display: flex;
  flex-direction: column;
}

.episode-header {
  padding: 14px 16px 12px;
  border-bottom: 1px solid #1a1f26;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.episode-title {
  color: #e8edf2;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.episode-count {
  color: #5a6672;
  font-size: 12px;
  background: #181e24;
  padding: 2px 10px;
  border-radius: 12px;
}

.episode-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.episode-list::-webkit-scrollbar {
  width: 3px;
}

.episode-list::-webkit-scrollbar-track {
  background: transparent;
}

.episode-list::-webkit-scrollbar-thumb {
  background: #2a3138;
  border-radius: 4px;
}

.episode-list::-webkit-scrollbar-thumb:hover {
  background: #3a4652;
}

.episode-item {
  display: flex;
  align-items: center;
  padding: 7px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  background: transparent;
  border: 1px solid transparent;
  gap: 6px;
}

.episode-item:hover:not(.locked) {
  background: #181e24;
  border-color: #1a1f26;
}

.episode-item.active {
  background: rgba(229, 9, 20, 0.15);
  border-color: #e50914;
}

.episode-item.active .episode-num {
  color: #e50914;
  font-weight: 700;
}

.episode-item.locked {
  opacity: 0.45;
}

.episode-item.locked .episode-num {
  color: #5a6672;
}

.episode-item.watched {
  opacity: 0.7;
}

.episode-item.watched .episode-num {
  color: #26a69a;
}

.episode-num {
  font-size: 14px;
  font-weight: 500;
  color: #8a949f;
  min-width: 28px;
  text-align: center;
}

.episode-label {
  font-size: 12px;
  color: #5a6672;
  margin-right: auto;
}

.episode-status {
  font-size: 12px;
  min-width: 20px;
  text-align: center;
}

.episode-status .lock-icon {
  font-size: 11px;
}

.episode-status .check-icon {
  color: #26a69a;
  font-size: 12px;
}

.episode-status .play-icon {
  color: #5a6672;
  font-size: 10px;
}

/* ============================================================
   解锁弹框 - 优化版
   ============================================================ */
.tk1box {
  position: absolute;
  bottom: -185px;
  left: 0;
  right: 0;
  background: rgba(14, 19, 24, 0.96);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  padding: 18px 28px 20px;
  border-radius: 20px 20px 0 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 -8px 40px rgba(0, 0, 0, 0.5);
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
  z-index: 10;
}

.tbup {
  bottom: 0;
}

/* ---- 顶部提示 ---- */
.xkg1t {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.lock-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: rgba(229, 9, 20, 0.15);
  border-radius: 50%;
  color: #e50914;
  font-size: 14px;
}

.lock-tip {
  color: #b0bcc8;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.3px;
}

/* ---- 余额 ---- */
.tb2bx {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.balance-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.04);
  padding: 4px 12px 4px 8px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.04);
}

.coin-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.balance-amount {
  color: #ffb300;
  font-size: 16px;
  font-weight: 700;
}

.recharge-link {
  color: #5a6672;
  font-size: 13px;
  text-decoration: none;
  transition: color 0.3s;
  font-weight: 400;
}

.recharge-link:hover {
  color: #e8edf2;
}

/* ---- 解锁按钮 ---- */
.tb33x {
  display: flex;
  gap: 12px;
}

.unlock-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 16px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
  position: relative;
  overflow: hidden;
}

.unlock-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

.unlock-btn:hover {
  transform: translateY(-2px) scale(1.01);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}

.unlock-btn:active {
  transform: scale(0.97);
}

.unlock-btn .btn-price {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.unlock-btn .btn-label {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.85;
}

/* 解锁全剧 - 红色 */
.unlock-all {
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
}

.unlock-all:hover {
  background: linear-gradient(135deg, #ff1a2a, #c40812);
}

/* 解锁单集 - 青色 */
.unlock-one {
  background: linear-gradient(135deg, #0f6b5f, #0a4f46);
  color: #fff;
}

.unlock-one:hover {
  background: linear-gradient(135deg, #148074, #0f6b5f);
}

/* ============================================================
   视频信息
   ============================================================ */
.content-wrapper {
  background: transparent;
  padding: 24px 0 0;
}

.content .name {
  color: #e8edf2;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 12px;
}

.content .desc_wrap {
  background: #0f1419;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid #1a1f26;
}

.content .desc {
  color: #b0bcc8;
  font-size: 14px;
  line-height: 1.8;
  font-weight: 400;
}

.tag {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0 0;
  list-style: none;
}

.tag .link_item {
  margin: 0;
}

.tag .link_item a {
  display: inline-block;
  color: #8a949f;
  font-size: 13px;
  text-decoration: none;
  padding: 4px 16px;
  border-radius: 20px;
  background: #181e24;
  border: 1px solid #1a1f26;
  transition: all 0.25s ease;
}

.tag .link_item a:hover {
  color: #e8edf2;
  background: #232b33;
  border-color: #2a3138;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1100px) {
  .player-container {
    flex: 0 0 640px;
  }
  .player-wrapper {
    width: 640px;
    height: 360px;
  }
  .episode-sidebar {
    max-height: 360px;
  }
}

@media (max-width: 920px) {
  .player-container {
    flex: 0 0 540px;
  }
  .player-wrapper {
    width: 540px;
    height: 304px;
  }
  .episode-sidebar {
    width: 180px;
    max-height: 304px;
  }
  .episode-item {
    padding: 5px 10px;
  }
  .episode-num {
    font-size: 13px;
    min-width: 24px;
  }
  .episode-label {
    font-size: 11px;
  }
}

@media (max-width: 820px) {
  .player-layout {
    flex-direction: column;
  }
  .player-container {
    flex: 1;
    width: 100%;
  }
  .player-wrapper {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }
  .episode-sidebar {
    width: 100%;
    max-height: 180px;
    border-radius: 12px;
  }
  .episode-list {
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: hidden;
    overflow-x: auto;
    padding: 6px 12px;
    gap: 4px;
  }
  .episode-list::-webkit-scrollbar {
    height: 3px;
  }
  .episode-item {
    padding: 5px 12px;
    flex-shrink: 0;
    min-width: 48px;
  }
  .episode-label {
    display: none;
  }
  .episode-header {
    padding: 10px 14px;
  }
  .episode-title {
    font-size: 14px;
    max-width: 100px;
  }

  .tk1box {
    padding: 14px 18px 16px;
  }
  .unlock-btn {
    padding: 8px 14px;
  }
  .unlock-btn .btn-price {
    font-size: 16px;
  }
  .unlock-btn .btn-label {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .pc_container {
    padding: 12px;
  }
  .video_breadcrumb {
    padding: 8px 0 12px;
  }
  .video_breadcrumb .home_link,
  .video_breadcrumb .title_dir a,
  .video_breadcrumb .title_dir {
    font-size: 12px;
  }
  .episode-sidebar {
    max-height: 140px;
  }
  .episode-item {
    padding: 4px 10px;
    min-width: 40px;
  }
  .episode-num {
    font-size: 12px;
    min-width: 20px;
  }
  .episode-status {
    display: none;
  }
  .content .name {
    font-size: 16px;
  }
  .content .desc_wrap {
    padding: 10px 14px;
  }
  .content .desc {
    font-size: 13px;
  }

  .tk1box {
    padding: 12px 14px 14px;
    bottom: -140px;
  }
  .tb33x {
    gap: 8px;
  }
  .unlock-btn {
    padding: 6px 10px;
    flex-direction: column;
    gap: 2px;
  }
  .unlock-btn .btn-price {
    font-size: 15px;
  }
  .unlock-btn .btn-label {
    font-size: 10px;
  }
  .lock-tip {
    font-size: 12px;
  }
  .balance-amount {
    font-size: 14px;
  }
}
</style>
